import * as yup from 'yup'

export const magentoConfigSchema = yup.object().shape({
  store: yup.string().trim().optional(),
  aggregator: yup.string().trim().optional(),
  inventoryLimit: yup
    .number()
    .typeError('inventoryLimit must be a number')
    .required('Inventory Limit is required')
    .integer()
    .min(1),
  pricingLimit: yup
    .number()
    .typeError('pricingLimit must be a number')
    .required('Pricing Limit is required')
    .integer()
    .min(1),
  catalogueLimit: yup
    .number()
    .typeError('catalogueLimit must be a number')
    .required('Catalogue Limit is required')
    .integer()
    .min(1),
  purchaseTimerLimit: yup
    .number()
    .typeError('purchaseTimerLimit must be a number')
    .optional()
    .integer()
    .min(1),
  magentoBaseUrl: yup
    .string()
    .trim()
    .url('Invalid Magento Base URL')
    .required('Magento Base URL is required'),
  magentoToken: yup.string().trim().required('Magento Token is required'),
  inventorySyncChunkSize: yup
    .number()
    .typeError('inventorySyncChunkSize must be a number')
    .required('Chunk Size is required')
    .integer()
    .min(1),
  isInventorySyncEnabled: yup.boolean().required(),
  syncBundleProduct: yup.boolean().required(),
})

export type MagentoConfigFormFields = yup.InferType<typeof magentoConfigSchema>
